function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { forwardRef, memo, useCallback, useRef } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhEye, dhEyeSlash, vsGripper } from '@deephaven/icons';
import { Button, Tooltip } from '@deephaven/components';
import VisibilityOrderingGroup from "./VisibilityOrderingGroup.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function emptyOnClick() {
  // no-op
}
var VisibilityOrderingItem = /*#__PURE__*/forwardRef(function VisibilityOrderingItem(props, ref) {
  var value = props.value,
    clone = props.clone,
    childCount = props.childCount,
    item = props.item,
    onVisibilityChange = props.onVisibilityChange,
    visibilityClickAndDrag = props.visibilityClickAndDrag,
    onClick = props.onClick,
    onGroupDelete = props.onGroupDelete,
    onGroupColorChange = props.onGroupColorChange,
    onGroupNameChange = props.onGroupNameChange,
    validateGroupName = props.validateGroupName,
    handleProps = props.handleProps;
  var _item$data = item.data,
    group = _item$data.group,
    modelIndex = _item$data.modelIndex,
    isVisible = _item$data.isVisible;
  var buttonRef = useRef(null);
  var handleVisibilityChange = useCallback(e => {
    if (e.buttons === 1) {
      var _buttonRef$current;
      onVisibilityChange([modelIndex].flat(), !isVisible);
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
  }, [onVisibilityChange, modelIndex, isVisible]);
  var handleClick = useCallback(event => {
    onClick(value, event);
  }, [onClick, value]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsxs("div", _objectSpread(_objectSpread({
      ref: ref,
      className: classNames('tree-item', {
        isSelected: item.selected,
        'two-dragged': childCount === 2,
        'multiple-dragged': childCount > 2
      }),
      onClick: handleClick,
      "data-index": item.index
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, handleProps), {}, {
      children: [!clone && /*#__PURE__*/_jsx(Button, {
        ref: buttonRef,
        kind: "ghost",
        className: "px-1"
        // We PropType validate onClick for Button
        ,
        onClick: emptyOnClick,
        onMouseDown: handleVisibilityChange,
        onMouseEnter: visibilityClickAndDrag ? handleVisibilityChange : undefined,
        icon: isVisible ? dhEye : dhEyeSlash,
        tooltip: "Toggle visibility"
      }), /*#__PURE__*/_jsx("span", {
        title: value,
        className: classNames('column-name', group && 'column-group'),
        children: group && !clone ? /*#__PURE__*/_jsx(VisibilityOrderingGroup, {
          group: group,
          onDelete: onGroupDelete,
          onColorChange: onGroupColorChange,
          onNameChange: onGroupNameChange,
          validateName: validateGroupName
        }) : value
      }), /*#__PURE__*/_jsxs("div", {
        children: [clone && childCount > 1 && /*#__PURE__*/_jsx("span", {
          className: "item-count",
          children: childCount
        }), !clone && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Tooltip, {
            children: "Drag to re-order"
          }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsGripper
          })]
        })]
      })]
    }))
  );
});
var MemoizedVisibilityOrderingItem = /*#__PURE__*/memo(VisibilityOrderingItem);
export default MemoizedVisibilityOrderingItem;
//# sourceMappingURL=VisibilityOrderingItem.js.map